// prefix "da" means "design-assets"

export const locatorsDropdown = {
    iconDefaultTrigger: () => 'vf-da-dropdown-icon-default-trigger',
    listItem: (itemKey) => `vf-da-dropdown-list-item-${itemKey}`,
};
